import React from 'react'
import FirstRowCell from './Cells/FirstRowCell'
import PropTypes from 'prop-types'
import CellSwitcher from './Cells/CellSwitcher'
import {observer} from 'mobx-react'
import ReactLoading from 'react-loading'
import '../Sass/Table.sass'
import '../Sass/stylesById.sass'

let Table = observer(props => {

    return (
        <div className='table'>
            {props.loading &&
            <div className={'table__loading'}
                 style={{
                     background: 'rgba(255,255,255,0.8)',
                     position: 'absolute',
                     left: 0,
                     transition: '500ms',
                     right: 0,
                     top: 0,
                     bottom: 0,
                     zIndex: 100,
                     display: 'flex',
                     justifyContent: 'center',
                     alignItems: 'center',
                     borderRadius: '10px'
                 }}>
                <ReactLoading height={200} width={200} type={'spin'} color={'#bce0fd'}/>
            </div>}
            <div className='handler'>
                <div className='table__title'>{props.title}</div>
                <button onClick={props.showFilterSidebar}>Фильтр</button>
                <div className='showCount'>
                    <div className='showCount__title'>Показывать по</div>

                    <select defaultValue={'20'}
                            onChange={e => props.showCountChangeHandler(e)}
                            className='select showCount__select'>

                        <option defaultValue value='20'>20</option>
                        <option value='50'>50</option>
                        <option value='100'>100</option>
                    </select>
                    <div className='showCount__title' style={{marginLeft: '20px'}}> из {props.pagination.resultsCount}
                    </div>

                </div>
            </div>

            <div className='table__content'>
                <div className='wrapper'>
                    <div id="first-row" className='table__row first-row'>
                        {props.firstRow ? props.firstRow.map((cell, index) => {
                            return <FirstRowCell
                                class={cell.class}
                                key={cell.id + cell.title + index}
                                haveSort={cell.id}
                                style={cell.style}
                                columnId={cell.columnId}
                                title={cell.title}
                                onClick={() => props.sortHandler(cell.id)}/>
                        }) : null}
                    </div>

                    {props.tableStorage ? props.tableStorage.map((row, index) => {
                        return <div key={row._id  + index} className='table__row'>

                            {props.haveToShow.map((cell, i) => {
                                const id = props.firstRow[i]?.id ? props.firstRow[i]?.id : props.firstRow[i]?.columnId
                                return <div key={cell.id + cell.type + props.firstRow[i].title + i}
                                            id={'column_' + id}
                                            onClick={_=> cell.onClick ? cell.onClick(row) : () => {} }
                                            style={props.firstRow[i]?.style}
                                            className={`cellWrapper ${cell.class}  ${'cell_' + props.firstRow[i].id}`}>

                                    <CellSwitcher type={cell.type}
                                                  all={row}
                                                  typeData={cell.typeData}
                                                  idArr={cell.idArr ? cell.idArr.map(item => {
                                                      return row[item]
                                                  }) : ''}
                                                  cellContent={row[cell.id]}/>

                                </div>
                            })}
                        </div>
                    }) : null}

                </div>
            </div>
            <style jsx='true'>{`
              #cell_fio .row_cell {
                text-align: left;
                width: 350px;
              }       
  
              #column_medBook {
                white-space: nowrap;
                text-overflow: unset;
                width: 150px;
              }

              #column_mistakes {
              min-width: 30px;
              display: flex;
              width: 20px;
              }

              #column_score {
              min-width: 30px;
              display: flex;
              width: 30px;
              }


            `}</style>
        </div>
    )
})

Table.propTypes = {
    title: PropTypes.string,
    showFilterSidebar: PropTypes.func,


    firstRow: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            id: PropTypes.string,
            sortFunction: PropTypes.func,
            haveSort: PropTypes.bool
        })).isRequired,

    haveToShow: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            type: PropTypes.string,
            typeData: PropTypes.object
        })),

    tableStorage: PropTypes.array
}


export default Table

